/*
  clomes-cart.js
  1. Accordion fuer Cart Note im Drawer
  2. Live-Update der Free-Shipping Progress Bar nach Cart-Aenderungen

  Einbinden via theme.liquid vor </body>:
  {{ 'clomes-cart.js' | asset_url | script_tag }}
*/

(function () {
  'use strict';

  /* ── 0. GLOBALER SCHWEIZER GELDFORMAT-PATCH ─────────────────────────────── */
  // Überschreibt Shopify.formatMoney für den gesamten Shop:
  // CHF 84.00 → CHF 84.-  |  CHF 60.90 bleibt CHF 60.90
  // Überschreibt Shopify.formatMoney – gilt für alle JS-gerenderten Preise
  (function patchShopifyFormatMoney() {
    if (typeof window.Shopify === 'undefined') return;
    var _orig = window.Shopify.formatMoney;
    if (!_orig) return;
    window.Shopify.formatMoney = function(cents, format) {
      var result = _orig.call(this, cents, format);
      return result.replace(/\.00\b/g, '.-');
    };
  })();

  // Patcht Liquid-gerenderte Preise im Cart Drawer + Cart Page (DOM-Scan)
  // Bewusst nur Cart-Kontext – kein Eingriff in Shop-weite Preisdarstellung
  function patchRenderedPrices() {
    var selectors = [
      '#CartDrawer .money',
      '#CartDrawer .price',
      '#CartDrawer [data-price]',
      '#CartPageForm .money',
      '#CartPageForm .price',
      '#CartPageForm [data-subtotal]',
      '.cart-page__mobile-bar .money'
    ].join(',');

    var elements = document.querySelectorAll(selectors);
    elements.forEach(function(el) {
      if (el.children.length === 0 && el.textContent.indexOf('.00') !== -1) {
        el.textContent = el.textContent.replace(/\.00\b/g, '.-');
      }
    });
  }

  /* ── 1. CART NOTE ACCORDION ──────────────────────────────────────────────── */

  function initCartNoteAccordion() {
    // Event delegation auf document: funktioniert auch nach Drawer-Re-render
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('.cart-note-accordion__toggle');
      if (!toggle) return;

      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      var panelId  = toggle.getAttribute('aria-controls');
      var panel    = document.getElementById(panelId);
      if (!panel) return;

      toggle.setAttribute('aria-expanded', String(!expanded));
      panel.hidden = expanded;
    });
  }


  /* ── 2. LIVE PROGRESS BAR ────────────────────────────────────────────────── */

  // Schwelle aus dem data-Attribut lesen das wir im Liquid setzen (in Rappen)
  function getThresholdCents() {
    var bar = document.querySelector('.cart-trust__progress');
    if (bar && bar.dataset.threshold) {
      return parseInt(bar.dataset.threshold, 10);
    }
    // Fallback: 10000 Rappen = CHF 100
    return 10000;
  }

  function formatMoney(cents) {
    // Schweizer Format: CHF 5.- bei ganzen Beträgen, CHF 5.90 sonst
    var franken = cents / 100;
    var formatted = franken % 1 === 0
      ? franken.toFixed(0) + '.-'
      : franken.toFixed(2);
    return 'CHF\u00a0' + formatted;
  }

  function updateProgressBar(cartTotalCents) {
    var thresholdCents = getThresholdCents();
    var remaining      = thresholdCents - cartTotalCents;
    var percent        = Math.min(Math.round(cartTotalCents * 100 / thresholdCents), 100);

    var fill = document.querySelector('.cart-trust__progress-fill');
    // Text ist jetzt im header mit anderem Klassennamen
    var text = document.querySelector('.cart-progress-bar-header__text');

    if (!fill || !text) return;

    fill.style.width = percent + '%';
    fill.closest('.cart-trust__progress').setAttribute('aria-valuenow', percent);

    if (remaining > 0) {
      text.className = 'cart-progress-bar-header__text';
      text.innerHTML = 'Noch <strong>' + formatMoney(remaining) + '</strong> bis kostenloser Versand';
    } else {
      text.className = 'cart-progress-bar-header__text cart-progress-bar-header__text--success';
      text.innerHTML = '<span class="cart-progress-bar__pill">Kostenloser Versand</span>';
    }
  }

  /* ── 2b. SUMMARY BLOCK (Total + Pill Badge) ──────────────────────────── */

  var SHIPPING_THRESHOLD_CENTS = 10000; // CHF 100
  var SHIPPING_COST_CENTS      = 500;   // CHF 5

  function updateSummaryBlock(cartTotalCents) {
    var subtotalEl   = document.querySelector('[data-subtotal]');
    var shippingNote = document.querySelector('.cart-summary__shipping-note');
    if (!subtotalEl || !shippingNote) return;

    if (cartTotalCents < SHIPPING_THRESHOLD_CENTS) {
      subtotalEl.textContent = formatMoney(cartTotalCents + SHIPPING_COST_CENTS);
      shippingNote.className = 'cart-summary__shipping-note';
      shippingNote.textContent = 'inkl. ' + formatMoney(SHIPPING_COST_CENTS) + ' Versand';
    } else {
      subtotalEl.textContent = formatMoney(cartTotalCents);
      shippingNote.className = 'cart-summary__shipping-note cart-summary__shipping-note--free';
      shippingNote.textContent = 'Versand kostenlos';
    }
  }

  function fetchCartAndUpdate() {
    fetch(window.theme && theme.routes ? theme.routes.cart : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        updateProgressBar(data.total_price);
        updateSummaryBlock(data.total_price);
      })
      .catch(function () { /* Stille Fehlerbehandlung – kein visueller Crash */ });
  }

  function initProgressBar() {
    // Auf Impulse-eigene Cart-Events hoeren (Mengenänderung im Drawer)
    document.addEventListener('cart:updated', fetchCartAndUpdate);
    document.addEventListener('cart:updated', patchRenderedPrices);
    document.addEventListener('cart:refresh', fetchCartAndUpdate);
    document.addEventListener('cart:refresh', patchRenderedPrices);
    document.addEventListener('theme:cart:change', fetchCartAndUpdate);
    document.addEventListener('theme:cart:change', patchRenderedPrices);

    // MutationObserver: Drawer-Öffnung erkennen via CSS-Klasse drawer--is-open
    // Nötig weil beim ersten Add-to-Cart kein cart:updated gefeuert wird
    var drawerEl = document.getElementById('CartDrawer');
    if (drawerEl && window.MutationObserver) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.attributeName === 'class') {
            var isOpen = drawerEl.classList.contains('drawer--is-open');
            if (isOpen) {
              fetchCartAndUpdate();
            }
          }
        });
      });
      observer.observe(drawerEl, { attributes: true, attributeFilter: ['class'] });
    }
  }


  /* ── 3. LIEFERDATUM ─────────────────────────────────────────────────────── */

  // Feiertage CH (Zürich/Bern) 2026 + 2027
  // Feiertage und Bestellschluss aus Theme Settings (via window.clomesDeliveryConfig).
  // Gepflegt unter Customizer → Theme Settings → Lieferdatum.
  // Fallback auf leeres Array / 15 Uhr falls Config fehlt.
  var _config     = window.clomesDeliveryConfig || {};
  var HOLIDAYS    = Array.isArray(_config.holidays)
                      ? _config.holidays.map(function(d) { return d.trim(); }).filter(Boolean)
                      : [];
  var CUTOFF_HOUR = typeof _config.cutoffHour === 'number' ? _config.cutoffHour : 15;

  var DE_DAYS   = ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'];
  var DE_MONTHS = ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'];

  function padDate(d) {
    return d < 10 ? '0' + d : '' + d;
  }

  function toDateString(date) {
    return date.getUTCFullYear() + '-' + padDate(date.getUTCMonth() + 1) + '-' + padDate(date.getUTCDate());
  }

  function isHoliday(date) {
    return HOLIDAYS.indexOf(toDateString(date)) !== -1;
  }

  function isWeekend(date) {
    return date.getDay() === 0 || date.getDay() === 6;
  }

  function nextWorkingDay(date) {
    var d = new Date(date);
    d.setDate(d.getDate() + 1);
    while (isWeekend(d) || isHoliday(d)) {
      d.setDate(d.getDate() + 1);
    }
    return d;
  }

  function calculateDeliveryDate() {
    // Aktuelle Zeit in Europe/Zurich (UTC+1 Winter, UTC+2 Sommer)
    var now = new Date();
    var zurichOffset = getZurichOffset(now);
    var zurichTime = new Date(now.getTime() + zurichOffset * 60000);
    var hour = zurichTime.getUTCHours();

    var shippingDate;
    if (hour >= CUTOFF_HOUR || isWeekend(zurichTime) || isHoliday(zurichTime)) {
      shippingDate = nextWorkingDay(zurichTime);
    } else {
      shippingDate = new Date(zurichTime);
    }
    return nextWorkingDay(shippingDate);
  }

  function getZurichOffset(date) {
    // Simplifizierte Sommerzeit-Berechnung für Europa/Zürich
    // Sommerzeit: letzter Sonntag März bis letzter Sonntag Oktober
    var year = date.getUTCFullYear();
    var dstStart = lastSundayOf(year, 2); // März = Monat 2 (0-basiert)
    var dstEnd   = lastSundayOf(year, 9); // Oktober = Monat 9
    var ts = date.getTime();
    if (ts >= dstStart && ts < dstEnd) {
      return 120; // UTC+2 (CEST)
    }
    return 60; // UTC+1 (CET)
  }

  function lastSundayOf(year, month) {
    // Letzter Sonntag eines Monats, 2:00 Uhr UTC
    var d = new Date(Date.UTC(year, month + 1, 1)); // erster Tag des Folgemonats
    d.setUTCDate(d.getUTCDate() - 1); // letzter Tag des Monats
    while (d.getUTCDay() !== 0) {
      d.setUTCDate(d.getUTCDate() - 1);
    }
    d.setUTCHours(2, 0, 0, 0); // Umstellung um 2:00 Uhr
    return d.getTime();
  }

  function formatDeliveryDate(date) {
    return DE_DAYS[date.getUTCDay()] + ', ' + date.getUTCDate() + '. ' + DE_MONTHS[date.getUTCMonth()];
  }

  function updateDeliveryDate() {
    var msg  = document.getElementById('cartDeliveryMessage');
    var span = document.getElementById('cartDeliveryDate');
    if (!msg || !span) return;

    var deliveryDate = calculateDeliveryDate();
    span.textContent = formatDeliveryDate(deliveryDate);
    msg.style.display = 'flex';
  }

  function initDeliveryDate() {
    // Beim Öffnen des Drawers aktualisieren
    document.addEventListener('cart:updated', updateDeliveryDate);
    document.addEventListener('cart:refresh', updateDeliveryDate);

    var drawerEl = document.getElementById('CartDrawer');
    if (drawerEl && window.MutationObserver) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.attributeName === 'class' && drawerEl.classList.contains('drawer--is-open')) {
            updateDeliveryDate();
          }
        });
      });
      observer.observe(drawerEl, { attributes: true, attributeFilter: ['class'] });
    }
  }



  /* ── 4. CART PAGE – Progress Bar + Lieferdatum ──────────────────────────── */

  function updateCartPageProgressBar(cartTotalCents) {
    var thresholdCents = 10000;
    var remaining      = thresholdCents - cartTotalCents;
    var percent        = Math.min(Math.round(cartTotalCents * 100 / thresholdCents), 100);

    // Mobile + Desktop IDs
    var ids = [
      { fill: 'cartPageProgressFill',  text: 'cartPageProgressText' },
      { fill: 'cartPageProgressFillD', text: 'cartPageProgressTextD' }
    ];

    ids.forEach(function(pair) {
      var fill = document.getElementById(pair.fill);
      var text = document.getElementById(pair.text);
      if (!fill || !text) return;

      fill.style.width = percent + '%';

      if (remaining > 0) {
        text.className = 'cart-progress-bar-header__text';
        text.innerHTML = 'Noch <strong>' + formatMoney(remaining) + '</strong> bis kostenloser Versand';
      } else {
        text.className = 'cart-progress-bar-header__text cart-progress-bar-header__text--success';
        text.innerHTML = '<span class="cart-progress-bar__pill">Kostenloser Versand</span>';
      }
    });
  }

  function updateCartPageSummary(cartTotalCents) {
    var subtotalEl   = document.querySelector('#CartPageForm [data-subtotal]');
    var shippingNote = document.querySelector('#CartPageForm .cart-summary__shipping-note');
    var mobileTotal  = document.getElementById('cartPageMobileTotal');

    var displayTotal = cartTotalCents < SHIPPING_THRESHOLD_CENTS
      ? cartTotalCents + SHIPPING_COST_CENTS
      : cartTotalCents;
    var formatted = formatMoney(displayTotal);

    // Nur updaten wenn Wert sich geändert hat – verhindert sichtbares Flackern
    if (subtotalEl && subtotalEl.textContent !== formatted) subtotalEl.textContent = formatted;
    if (mobileTotal && mobileTotal.textContent !== formatted) mobileTotal.textContent = formatted;

    if (shippingNote) {
      if (cartTotalCents < SHIPPING_THRESHOLD_CENTS) {
        shippingNote.className = 'cart-summary__shipping-note';
        shippingNote.textContent = 'inkl. ' + formatMoney(SHIPPING_COST_CENTS) + ' Versand';
      } else {
        shippingNote.className = 'cart-summary__shipping-note cart-summary__shipping-note--free';
        shippingNote.textContent = 'Versand kostenlos';
      }
    }
  }

  function updateCartPageDeliveryDate() {
    var deliveryDate = calculateDeliveryDate();
    var formatted = formatDeliveryDate(deliveryDate);

    // Desktop
    var msg  = document.getElementById('cartPageDeliveryMessage');
    var span = document.getElementById('cartPageDeliveryDate');
    if (msg && span) { span.textContent = formatted; msg.style.display = 'flex'; }

    // Mobile Bar
    var mobileDate = document.getElementById('cartPageMobileDate');
    if (mobileDate) mobileDate.textContent = formatted;
  }

  function fetchCartPageAndUpdate() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        updateCartPageProgressBar(data.total_price);
        updateCartPageSummary(data.total_price);
      })
      .catch(function() {});
  }

  // Sofort-Patch: liest DOM-Wert und konvertiert .00 → .- ohne auf Fetch zu warten
  function instantPatchCartPage() {
    var els = document.querySelectorAll(
      '#CartPageForm [data-subtotal], #cartPageMobileTotal, #cartPageProgressText, #cartPageProgressTextD'
    );
    els.forEach(function(el) {
      if (el.children.length === 0) {
        el.textContent = el.textContent.replace(/\.00\b/g, '.-');
      } else {
        el.innerHTML = el.innerHTML.replace(/\.00\b/g, '.-');
      }
    });
    // Auch shipping note
    var note = document.querySelector('#CartPageForm .cart-summary__shipping-note');
    if (note) note.textContent = note.textContent.replace(/\.00\b/g, '.-');
  }

  function initCartPageNoteAccordion() {
    document.addEventListener('click', function(e) {
      var toggle = e.target.closest('.cart-page__note-toggle');
      if (!toggle) return;
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      var panel = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!panel) return;
      toggle.setAttribute('aria-expanded', String(!expanded));
      panel.hidden = expanded;
    });
  }

  function initCartPage() {
    if (!document.getElementById('CartPageForm')) return;
    initCartPageNoteAccordion();

    fetchCartPageAndUpdate();
    updateCartPageDeliveryDate();

    document.addEventListener('cart:updated', instantPatchCartPage);
    document.addEventListener('cart:updated', fetchCartPageAndUpdate);
    document.addEventListener('cart:updated', updateCartPageDeliveryDate);

    var form = document.getElementById('CartPageForm');
    if (form) {
      form.addEventListener('change', function(e) {
        if (e.target.name === 'updates[]' || e.target.name === 'quantity') {
          setTimeout(fetchCartPageAndUpdate, 300);
        }
      });
    }
  }

  /* ── INIT ────────────────────────────────────────────────────────────────── */

  function init() {
    patchRenderedPrices();
    initCartNoteAccordion();
    initProgressBar();
    initDeliveryDate();
    initCartPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
